import { render, staticRenderFns } from "./myEventManage.vue?vue&type=template&id=1bd28201&scoped=true&"
import script from "./myEventManage.vue?vue&type=script&lang=js&"
export * from "./myEventManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd28201",
  null
  
)

export default component.exports